import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useRecoilValue } from 'recoil';

import { getDfiAnnualReportDocumentPath } from 'api';
import { DfiReportDocumentPathResponse } from 'types';
import { annualDfiReportYearState } from 'store';

export const useDfiAnnualReportPdf = (
  fileName: string
): UseMutationResult<DfiReportDocumentPathResponse> => {
  const reportYear = useRecoilValue(annualDfiReportYearState);
  return useMutation(() => getDfiAnnualReportDocumentPath(reportYear), {
    onSuccess: (data) => {
      const link = document.createElement('a');
      link.href = data.documentUri;
      link.target = '_blank';
      link.download = `${fileName.replaceAll(' ', '_')}.pdf`;
      link.click();
    },
  });
};
